/* This is mostly used as a no-op since tslint doesn't like empty blocks. */
export function identity(whatever?: any): any {
  return whatever
}
